import { render, staticRenderFns } from "./AppAnomaliasArrow.vue?vue&type=template&id=072afef2&scoped=true&"
import script from "./AppAnomaliasArrow.vue?vue&type=script&lang=js&"
export * from "./AppAnomaliasArrow.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomaliasArrow.vue?vue&type=style&index=0&id=072afef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072afef2",
  null
  
)

export default component.exports